import { AdminRoutes } from "./private";
export const PrivateRoutes = [...AdminRoutes];
